import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import { DescriptionBoxMessages as messages } from './DescriptionBox.i18n';

export class DescriptionBox extends React.Component {
  renderPrintButton() {
    return (
        <button
          type="button"
          className="btn btn-link theme float-right"
          onClick={this.props.printClickHandler}
        >
          <span className="fa-solid fa-print mr-1" aria-hidden="true"></span>
          <FormattedMessage { ...messages.labels.print } />
        </button>
    );
  }

  render() {
    const { content, showPrintButton } = this.props;

    return (
      <div className="card description-box small mb-3">
        <div className="card-body">
          { showPrintButton ? this.renderPrintButton() : null }
          { content }
        </div>
      </div>
    );
  }
}

DescriptionBox.propTypes = {
  content: PropTypes.object,
  showPrintButton: PropTypes.bool,
  printClickHandler: PropTypes.func,
};
